import axios from "axios";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _orderInfoBaseUrl = "/Customer/Order";
const orderInfo = axios.create({
  baseURL: checkEnvironment(_basic, _orderInfoBaseUrl)
});




/**
 * 門市對單資料
 * @param {string} orderCode
 * @param {number} langId
 */
export const getOrderInfo = async (orderCode, langId, waiterID, storeID, createAt, posCode, posTableNo) => {
  return await orderInfo.get("/GetOrderPreparation", {
    params: {
      orderCode,
      languageID: langId,
      waiterID,
      storeID,
      createAt,
      posCode,
      posTableNo,
    }
  });
};
export const updateOrderPreperationStatus = async (orderCode, langId, waiterID, storeID, createAt, posCode, posTableNo) => {
  return await orderInfo.get("/updateOrderPreperationStatus", {
    params: {
      orderCode,
      languageID: langId,
      waiterID,
      storeID,
      createAt,
      posCode,
      posTableNo,
     
    }
  });
};

/**
 * 儲存預點單
 * @param {*} saveData
 */
export const postSaveOrder = async saveData => {
  return await orderInfo.post("/SetOrderSave", saveData);
};

/**
 * 儲存預點單
 * @param {*} saveData
 */
export const postAddSaveOrder = async saveData => {
  return await orderInfo.post("/AddOrderSave", saveData);
};

/**
 * staffSearchOrder 查詢訂單
 * @param {number} storeId
 * @param {number} langId
 * @param {string} date yyyy/MM/dd
 * @param {number} status
 */
export const getOrderList = async (storeId, langId, date, status) => {
  return await orderInfo.get("/GetOrderList", {
    params: {
      storeID: storeId,
      languageID: langId,
      datetime: date,
      status: status,
      ClearTime: ''
    }
  });
};

/**
 * 修改單一產品的資料
 * @param {string} orderCode
 * @param {number} languageId
 */
export const getOrderProductList = async (orderCode, languageId, storeID, createAt) => {
  return await orderInfo.get("/GetOrderAddProductList", {
    params: {
      orderCode,
      languageID: languageId,
      storeID,
      createAt
    }
  });
};

/**
 * 修改訂單狀態
 * @param {*} orderStatus
 */
export const postChangeOrderStatus = async orderStatus => {
  return await orderInfo.post("/SetOrderStatus", orderStatus);
};

/**
 * 點餐明細
 * @param {string} orderCode
 * @param {number} langId
 */
export const getOrderDetail = async (orderCode, langId, storeID, createAt) => {
  return await orderInfo.get("/GetOrderDetail", {
    params: {
      orderCode,
      languageID: langId,
      storeID,
      createAt
    }
  });
};

/**
 * 重印預點單
 * @param {string} posCode
 * @param {string} orderCode
 * @param {number} storeID
 */
export const getOrderReprintPreOrder = async (posCode, orderCode, storeID) => {
  return await orderInfo.get("/ReprintPreOrder", {
    params: {
      posCode,
      orderCode,
      storeID
    }
  });
};

